import type { AcknowledgmentCommitmentItem } from '../model/types'

import { isCurrentUserCommitment } from './buildAcknowledgmentStatusView'

/** A row the server holds (`-1`) for the reader: their own signature, or the reminder to another. */
export const isBlockedForReader = (item: AcknowledgmentCommitmentItem, currentUserEmail: string) =>
  isCurrentUserCommitment(item, currentUserEmail) ? item.CanSignOff < 0 : item.CanResend < 0

/**
 * Why the server holds the reader's act on this plan: the `AlertKey` it sends with a held row — a
 * translation key or a ready sentence, e.g. `Print offering is not completed`. `null` when nothing
 * is held or the server gives no reason.
 */
export const getBlockedSignOffReason = (
  items: AcknowledgmentCommitmentItem[],
  currentUserEmail: string
) =>
  items
    .find((item) => isBlockedForReader(item, currentUserEmail) && item.AlertKey?.trim())
    ?.AlertKey?.trim() ?? null
